export const getDateFromTimeStamp = (unix_timestamp) => {
  let dt = new Date(unix_timestamp);
  return dt.setHours(0, 0, 0, 0);
};

export const getFormatted2Digits = (val) => ("0" + val).slice(-2);

export const getFormattedDate = (unix_timestamp) => {
  let dt = new Date(unix_timestamp);
  return `${getFormatted2Digits(dt.getDate())}.${getFormatted2Digits(dt.getMonth() + 1)}.${dt.getFullYear()}`;
};

export const getFormattedDateTime = (unix_timestamp, full = false) => {
  let date = new Date(unix_timestamp);
  // Hours part from the timestamp
  let hours = date.getHours();
  // Minutes part from the timestamp
  let minutes = "0" + date.getMinutes();
  let formattedTime = `${hours}:${minutes.substr(-2)}`; //hours + ":" + minutes.substr(-2);
  if (full) formattedTime = `${getFormattedDate(unix_timestamp)} ${formattedTime}`;

  return formattedTime;
};
